<nb-card *ngIf="!isLoaded">
    <nb-card-header>{{title}}</nb-card-header>
    <nb-card-body>
        <div class="container">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
    </nb-card-body>
</nb-card>